
import { ALL_ITEMS_RETURNED, ITEM_RETURNED, LEVEL_COMPLETE } from "Data/Topics";
import { InteriorLuna } from "GameObjects/GameInterior/InteriorLuna";
import type { IItemState } from "Interfaces/IItemState";
import type { ILevelState } from "Interfaces/ILevelState";

// import "vendor/pixi-spine-debug";

export class InteriorLunaReturnItems extends InteriorLuna {

    protected left: number = 145; // eyeballed
    protected bottom: number = 0;

    constructor() {
        super();
        this._subscriptions.push(
            PubSub.subscribe(ITEM_RETURNED, this.OnItemReturned.bind(this)),
            PubSub.subscribe(ALL_ITEMS_RETURNED, this.OnAllItemsReturned.bind(this)),
            PubSub.subscribe(LEVEL_COMPLETE, this.OnLevelCompleted.bind(this)),
        );
    }

    public HatOn() {
        this.playAnimation("idle-hat-on");
    }

    public HatOff() {
        this.playAnimation("idle-hat-off");
    }

    protected OnItemReturned(state: IItemState) {
        // console.log("item returned: ", state);
    }

    protected OnAllItemsReturned(state: ILevelState) {
        //
    }

    protected OnLevelCompleted(state: ILevelState) {
        //
    }

}
